"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppShell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const components_1 = require("../../../components");
const AppContext_1 = require("../TemplatesCollection/AppContext");
const CollectionOverview_1 = require("./CollectionOverview");
const TemplatesOverview_1 = require("./TemplatesOverview");
function AppShell() {
    const { fragment } = (0, react_1.useContext)(AppContext_1.AppContext);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.MenuShell, { visible: fragment === 'templates', animation: 'slide-left', children: (0, jsx_runtime_1.jsx)(TemplatesOverview_1.TemplatesOverviewContainer, {}) }), (0, jsx_runtime_1.jsx)(components_1.MenuShell, { visible: fragment === 'collections', animation: 'slide-right', children: (0, jsx_runtime_1.jsx)(CollectionOverview_1.CollectionOverviewContainer, {}) })] }));
}
exports.AppShell = AppShell;
//# sourceMappingURL=AppShell.js.map